/**
 * The wording every async area shares, keyed by what the area holds
 * (`label`, e.g. 'users'). Used by AsyncArea and the table loading/error
 * rows so the same area reads the same way wherever it renders.
 */

import { getErrorMessage } from '@/utils/errorUtils';

/** "Loading users…", or "Loading…" without a label. */
export function loadingMessage(label?: string): string {
  return label ? `Loading ${label}…` : 'Loading…';
}

/** "Couldn't load users", or "Couldn't load this" without a label. */
export function loadFailedTitle(label?: string): string {
  return `Couldn't load ${label ?? 'this'}`;
}

/** "Couldn't save template" — the heading for a failed action (`action` is
 * the verb and the thing, e.g. 'save template'). */
export function actionFailedTitle(action: string): string {
  return `Couldn't ${action}`;
}

/**
 * The toast for a failed one-click action:
 * "Couldn't delete agent — Something went wrong on our side."
 * The reason comes from getErrorMessage, so it never shows raw transport text.
 */
export function actionFailedMessage(action: string, error: unknown): string {
  return `${actionFailedTitle(action)} — ${getErrorMessage(error)}`;
}
